<!--
	Inline "section unavailable" message rendered inside a Legend section when
	its backing layer is null (i.e. not included in the current subscription /
	jurisdiction).
-->
<p class="notAvailable">Data not included in your current subscription</p>

<style>
	.notAvailable {
		color: var(--text-muted);
		font-size: var(--font-size-sm);
	}
</style>
